import * as actionTypes from './actionTypes';

export const searchTags = (search, options = {}) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_SEARCH_START });
        window.flow.searchTags(search, options).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_SEARCH_SUCCESS, tags: res });
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_SEARCH_FAIL });
        });
    };
};

export const newTag = (tag) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_NEW_START });
        window.flow.newTag(tag).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_NEW_SUCCESS });
            dispatch(searchTags("", { op: 'listall' }));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_NEW_FAIL });
        });
    };
};

export const editTag = (id, tag) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_EDIT_START });
        window.flow.editTag(id, tag).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_EDIT_SUCCESS });
            dispatch(searchTags("", { op: 'listall' }));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_EDIT_FAIL });
        });
    };
};

export const deleteTag = (id) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_DELETE_START });
        window.flow.delTag(id).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_DELETE_SUCCESS });
            dispatch(searchTags("", { op: 'listall' }));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_DELETE_FAIL });
        });
    };
};

export const newRelation = (rel, tagIdA, tagIdB) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_NEW_REL_START });
        window.flow.newRelation(rel).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_NEW_REL_SUCCESS });
            dispatch(relatedTags(tagIdA));
            dispatch(relatedTags(tagIdB));
            //dispatch(searchTags("", { op: 'listall' }));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_NEW_REL_FAIL });
        });
    };
};

export const delRelation = (id, tagIdA, tagIdB) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_DELETE_REL_START });
        window.flow.delRelation(id).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_DELETE_REL_SUCCESS });
            //dispatch(searchTags("", { op: 'listall' }));
            dispatch(relatedTags(tagIdA));
            dispatch(relatedTags(tagIdB));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_DELETE_REL_FAIL });
        });
    };
};

export const relatedTags = (id, rel = {}) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TAG_CATALOG_TAGS_REL_START });
        window.flow.relatedTags(id, rel).then((res) => {
            console.log(res);
            dispatch({ type: actionTypes.TAG_CATALOG_TAGS_REL_SUCCESS, id: id, rels: res });
            //dispatch(searchTags("", { op: 'listall' }));
        }).catch(res => {
            dispatch({ type: actionTypes.TAG_CATALOG_TAGS_REL_FAIL });
        });
    };
};
